import React from 'react';
import { Route } from 'react-router';

import Account from '../../components/Pages/Account';


const routes = <Route path="account" component={Account.LandingPage} />;

export default routes;



// WEBPACK FOOTER //
// ./src/routes/www/account.js